/** Shared geometry for building a culling viewport box from a raw map box. */

import { CLIENT_CONFIG } from '@/config';
import type { ViewportBox } from '@/stores/map-viewport-store';

/** Expand a box outward by the configured margin fraction (lat clamped to ±89). */
export function expandBox(box: ViewportBox): ViewportBox {
  const margin = CLIENT_CONFIG.viewportMarginFraction;
  const latPad = (box.north - box.south) * margin;
  const lngPad = (box.east - box.west) * margin;
  return {
    north: Math.min(box.north + latPad, 89),
    south: Math.max(box.south - latPad, -89),
    east: box.east + lngPad,
    west: box.west - lngPad,
  };
}

/** Center point of a box. */
export function boxCenter(box: ViewportBox): { lat: number; lng: number } {
  return { lat: (box.north + box.south) / 2, lng: (box.east + box.west) / 2 };
}
